/* =========================================================
   assets/neb-cards.js — MINIMAL
   Only handles "View & Buy" button.
   - Opens quick view if window.NebQuickView.open exists
   - Otherwise redirects to product URL
========================================================= */
(function () {
  'use strict';

  function extractHandleFromUrl(productUrl) {
    try {
      var u = new URL(productUrl, window.location.origin);
      var m = u.pathname.match(/\/products\/([^\/]+)/);
      return m ? m[1] : '';
    } catch (e) {
      var m2 = String(productUrl || '').match(/\/products\/([^\/\?]+)/);
      return m2 ? m2[1] : '';
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.neb-buy-now-btn');
      if (!btn) return;

      var card = btn.closest('.neb-card');

      // stop default behavior
      e.preventDefault();
      e.stopPropagation();

      // Prefer URL explicitly set on the button in liquid:
      // <button class="neb-buy-now-btn" data-product-url="{{ url0 }}">
      var productUrl =
        (btn.getAttribute('data-product-url') || '').trim() ||
        (card && (card.getAttribute('data-product-url') || '').trim()) ||
        (btn.getAttribute('href') || '').trim();

      if (!productUrl) return;

      // If you still keep variant id input on card, we’ll pass it.
      // Otherwise this will be empty and quickview/redirect will open base product URL.
      var variantId = '';
      if (card) {
        var idInput = card.querySelector('.neb-variant-id-input');
        if (idInput && idInput.value) variantId = String(idInput.value).trim();
      }

      var handle =
        (btn.getAttribute('data-product-handle') || '').trim() ||
        (card && (card.getAttribute('data-product-handle') || '').trim()) ||
        extractHandleFromUrl(productUrl);

      // ✅ Open quick view if available
      if (window.NebQuickView && typeof window.NebQuickView.open === 'function') {
        window.NebQuickView.open({
          handle: handle,
          variantId: variantId,
          productUrl: productUrl
        });
        return;
      }

      // Fallback: redirect
      var url = productUrl;
      if (variantId) {
        try {
          var u2 = new URL(productUrl, window.location.origin);
          u2.searchParams.set('variant', variantId);
          url = u2.toString();
        } catch (err) {
          url =
            productUrl +
            (productUrl.indexOf('?') !== -1 ? '&' : '?') +
            'variant=' +
            encodeURIComponent(variantId);
        }
      }
      window.location.href = url;
    },
    { capture: true }
  );
})();
(function () {

  // Swatch change → update image + View & Buy URL
  document.addEventListener("change", function (e) {

    const input = e.target.closest(".neb-swatch-input");
    if (!input) return;

    const card = input.closest(".neb-card");
    if (!card) return;

    // Change image
    const img = card.querySelector("[data-neb-card-img]");
    const imgUrl = input.getAttribute("data-image-url");
    if (img && imgUrl) {
      img.src = imgUrl;
      img.removeAttribute("srcset");
    }

    // Update View & Buy button
    const btn = card.querySelector(".neb-buy-now-btn");
    const variantUrl = input.getAttribute("data-variant-url");
    if (btn && variantUrl) {
      btn.setAttribute("data-product-url", variantUrl);
    }

  }, true);


  // Prevent swatch click from triggering product link
  document.addEventListener("click", function (e) {

    if (e.target.closest("[data-neb-swatch-indicator]")) {
      if (!e.target.closest("[data-neb-swatch-more]")) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    const moreBtn = e.target.closest("[data-neb-swatch-more]");
    if (moreBtn) {
      const url = moreBtn.getAttribute("data-product-url");
      if (url) window.location.href = url;
    }

  }, true);

})();